
// Premium Scroll & Interaction Engine
(function() {
    // Nuclear option: Custom interactive canvas dot grid
    const injectCustomBanner = () => {
        const bannerSection = document.querySelector('.banner, .hero, .hero-banner, [id*="hero"], [id*="banner"]');
        if (bannerSection && !bannerSection.classList.contains('custom-ag-injected')) {
            bannerSection.classList.add('custom-ag-injected');
            
            bannerSection.innerHTML = `
                <div class="custom-ag-banner" style="width:100%; min-height:600px; display:flex; flex-direction:column; align-items:center; justify-content:center; position:relative; overflow:hidden; background-color:#030303; margin-bottom:40px;">
                    <canvas id="ag-canvas" style="position:absolute; top:0; left:0; width:100%; height:100%; z-index:1; pointer-events:none;"></canvas>
                    <h2 style="color:#ffffff; text-shadow:0 0 20px rgba(0,255,255,0.8); z-index:10; font-size:clamp(2rem, 5vw, 4rem); font-weight:bold; margin-bottom:20px; text-align:center; padding:0 20px; pointer-events:none;">Deploy Your Digital Workforce</h2>
                    <a href="/collections/all" style="z-index:10; background:transparent; color:#00FFFF; border:2px solid #00FFFF; padding:15px 40px; border-radius:30px; font-weight:bold; text-decoration:none; transition:all 0.3s ease; text-transform:uppercase; letter-spacing:1px;" onmouseover="this.style.background='#00FFFF'; this.style.color='#000'; this.style.boxShadow='0 0 20px rgba(0,255,255,0.6)';" onmouseout="this.style.background='transparent'; this.style.color='#00FFFF'; this.style.boxShadow='none';">View Products</a>
                </div>
            `;

            // Canvas Interactive WAVE Grid Setup
            const cb = bannerSection.querySelector('.custom-ag-banner');
            const canvas = document.getElementById('ag-canvas');
            const ctx = canvas.getContext('2d');
            
            let width, height;
            let dots = [];
            const spacing = 35; // Space between dots
            let mouse = { x: -1000, y: -1000, px: -1000, py: -1000 };

            function initCanvas() {
                width = cb.offsetWidth;
                height = cb.offsetHeight;
                // Support high-DPI displays
                const dpr = window.devicePixelRatio || 1;
                canvas.width = width * dpr;
                canvas.height = height * dpr;
                ctx.scale(dpr, dpr);
                
                dots = [];
                const cols = Math.floor(width / spacing) + 2;
                const rows = Math.floor(height / spacing) + 2;
                const offsetX = (width - (cols - 1) * spacing) / 2;
                const offsetY = (height - (rows - 1) * spacing) / 2;
                
                for(let ix=0; ix<cols; ix++) {
                    for(let iy=0; iy<rows; iy++) {
                        dots.push({
                            baseX: offsetX + ix * spacing,
                            baseY: offsetY + iy * spacing,
                            x: offsetX + ix * spacing,
                            y: offsetY + iy * spacing,
                            vx: 0,
                            vy: 0
                        });
                    }
                }
            }

            function animateCanvas() {
                ctx.clearRect(0, 0, width, height);
                
                // Calculate mouse velocity for pushing
                let mouseVx = mouse.x - mouse.px;
                let mouseVy = mouse.y - mouse.py;
                mouse.px = mouse.x;
                mouse.py = mouse.y;
                
                for(let i=0; i<dots.length; i++) {
                    let dot = dots[i];
                    
                    let dx = mouse.x - dot.x;
                    let dy = mouse.y - dot.y;
                    let distance = Math.sqrt(dx*dx + dy*dy);
                    
                    // Interaction: If mouse is close, push dots based on mouse movement
                    if(distance < 120) {
                        let force = (120 - distance) / 120;
                        // Push dots away from cursor
                        dot.vx -= (dx / distance) * force * 1.5;
                        dot.vy -= (dy / distance) * force * 1.5;
                        // Add a bit of the mouse's velocity to create a drag/wake effect
                        dot.vx += mouseVx * force * 0.05;
                        dot.vy += mouseVy * force * 0.05;
                    }
                    
                    // Spring physics: pull back to base position
                    let targetDx = dot.baseX - dot.x;
                    let targetDy = dot.baseY - dot.y;
                    
                    dot.vx += targetDx * 0.08; // Spring stiffness
                    dot.vy += targetDy * 0.08;
                    
                    // Friction/Damping: slow down over time
                    dot.vx *= 0.82;
                    dot.vy *= 0.82;
                    
                    // Update position
                    dot.x += dot.vx;
                    dot.y += dot.vy;
                    
                    // Visuals based on kinetic energy
                    let speed = Math.sqrt(dot.vx*dot.vx + dot.vy*dot.vy);
                    let radius = 1.2 + speed * 0.4;
                    let opacity = 0.15 + speed * 0.1;
                    
                    if(radius > 4.5) radius = 4.5;
                    if(opacity > 1) opacity = 1;
                    
                    ctx.beginPath();
                    ctx.arc(dot.x, dot.y, Math.max(0.1, radius), 0, Math.PI * 2);
                    ctx.fillStyle = `rgba(0, 255, 255, ${opacity})`;
                    ctx.fill();
                }
                requestAnimationFrame(animateCanvas);
            }

            window.addEventListener('resize', initCanvas);
            cb.addEventListener('mousemove', e => {
                const rect = cb.getBoundingClientRect();
                mouse.x = e.clientX - rect.left;
                mouse.y = e.clientY - rect.top;
            });
            cb.addEventListener('mouseleave', () => {
                mouse.x = -1000;
                mouse.y = -1000;
            });

            initCanvas();
            animateCanvas();
        }
    };
    injectCustomBanner();
    setInterval(injectCustomBanner, 500);

    // Load GSAP
    const scripts = [
        'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.2/gsap.min.js',
        'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.2/ScrollTrigger.min.js'
    ];

    function loadScripts(urls, callback) {
        let loaded = 0;
        urls.forEach(url => {
            const s = document.createElement('script');
            s.src = url;
            s.onload = () => {
                loaded++;
                if (loaded === urls.length) callback();
            };
            document.head.appendChild(s);
        });
    }

    loadScripts(scripts, () => {
        gsap.registerPlugin(ScrollTrigger);

        // 1. Reveal Animation for Cards
        const revealElements = document.querySelectorAll('.card-wrapper, .product-card-wrapper, .collection-list__item');
        revealElements.forEach((el, i) => {
            gsap.from(el, {
                scrollTrigger: {
                    trigger: el,
                    start: "top 90%",
                    toggleActions: "play none none reverse"
                },
                opacity: 0,
                y: 50,
                duration: 0.8,
                delay: i % 3 * 0.1, // Stagger effect
                ease: "power2.out"
            });
        });

        // 2. 3D Blowup for hero/video sections
        const blowupTargets = document.querySelectorAll('.blowup-target');
        blowupTargets.forEach(target => {
            gsap.to(target, {
                scale: 1.5,
                scrollTrigger: {
                    trigger: target.parentElement,
                    start: "top center",
                    end: "bottom top",
                    scrub: 1,
                    pin: true
                }
            });
        });
    });

    // Mobile Hover Fix (Force touch as hover)
    document.addEventListener('touchstart', function() {}, {passive: true});
})();
